import(/* webpackMode: "eager" */ "/workspace/app/price/page.tsx");
